// src/modules/operaciones/inventarios/utils/preciosComun.js
//
// Constantes y helpers compartidos por el módulo "Ajustar Precios" (vista, hook, modal y componentes).
// (Movido tal cual desde InventariosPrecios.js. No reemplaza a utils/api.js ni a negativosComun.js: este pedirJson tiene su propia firma.)

export const API_URL = `${process.env.REACT_APP_API_URL || "http://localhost:5000"}/api/invent`; // URL base de la API de inventarios
export const POR_PAGINA = 50; // Filas por página en la tabla
export const AVISO_LENTO_MS = 20000; // Tiempo tras el cual se muestra el aviso de carga lenta
export const MSG_VACIO = 'No hay artículos con costo promedio 0 o saldo negativo para los filtros seleccionados.'; // Mensaje cuando no hay resultados

// Opciones del filtro de estado del artículo (se envía al backend)
export const OPCIONES_ESTADO = [
  { value: 'todos', label: 'Todos los estados' },
  { value: 'activos', label: 'Solo activos' },
  { value: 'inactivos', label: 'Solo inactivos' },
];

// Opciones del filtro por tipo de alerta (se aplica en el cliente)
export const OPCIONES_TIPO = [
  { value: 'todos', label: 'Todas las alertas' },
  { value: 'costo_cero', label: 'Solo costo 0' },
  { value: 'negativos', label: 'Solo negativos' },
];

export const COLUMNAS_NUMERICAS = new Set(['EXISTENCIA_TOTAL', 'COSTO_PROMEDIO']); // Columnas que se ordenan como número (no como texto)

// Apariencia y ayuda (tooltip) de cada tipo de alerta
export const BADGES = {
  COSTO_CERO: { clase: 'bg-red-500/20 text-red-500 border-red-500/40', label: '⚠️ Costo 0', ayuda: 'Saldo positivo con costo promedio 0' },
  NEGATIVO: { clase: 'bg-amber-500/20 text-amber-600 border-amber-500/40', label: '📉 Negativo', ayuda: 'Existencia total negativa' },
};

// Color del saldo: rojo si es negativo, azul si es positivo, gris si es cero
export const colorSaldo = (n) => (n < 0 ? 'text-red-500' : n > 0 ? 'text-blue-500' : 'text-gray-400');

// GET que devuelve el JSON ya validado ({ success: true, ... }) o lanza Error con el mensaje del backend
export const pedirJson = async (url, signal) => {
  const res = await fetch(url, { signal }); // `signal` permite cancelar la petición
  const data = await res.json().catch(() => ({})); // Si el cuerpo no es JSON, se usa un objeto vacío
  if (!res.ok || !data.success) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
};